<div class="root-container">
  <div class="portfolio-list">
    <dx-select-box
      [value]="this.selectedPortfolio"
      [selectedItem]="this.selectedPortfolio"
      (valueChange)="this.onPortfolioChange($event)"
      [grouped]="true"
      [items]="this.portfolios"
      displayExpr="name"
      fieldTemplate="field"
    >
      <div *dxTemplate="let data of 'field'">
        <div>
          <dx-text-box [readOnly]="true"
                       [value]="data && data.userName + '  |  ' + data.name"
                       placeholder="Select portfolio...">
          </dx-text-box>
        </div>
      </div>
    </dx-select-box>
  </div>
  <div class="refresh-btn" [ngClass]="this.getRefreshPortfolioCss() | etsNgClassAsync:this">
    <dx-button (onClick)="this.refreshPortfolio(this.selectedPortfolio)"
               [disabled]="!this.canRefreshPortfolio"
               icon="refresh"
    ></dx-button>
  </div>
  <div class="create-btn">
    <dx-button (onClick)="this.onCreateIndependentPortfolio()"
               icon="plus"
               hint="New Independent Portfolio"
    ></dx-button>
  </div>
  <div class="delete-btn">
    <dx-button (onClick)="this.onDeleteIndependentPortfolio()"
               [disabled]="!this.canDeletePortfolio"
               icon="remove"
               hint="Delete Independent Portfolio"
    ></dx-button>
  </div>
</div>

<ets-hg-hedge-positions-sync-dialog>
</ets-hg-hedge-positions-sync-dialog>

<ets-hg-create-portfolio-dialog>
</ets-hg-create-portfolio-dialog>

<ets-generic-confirmation-dialog
  #deletePortfolioDialog
  confirmText="Yes"
  rejectText="No"
  title="Delete Portfolio?"
>
</ets-generic-confirmation-dialog>
